import { useMutation } from 'react-query';
import usePlanStore from 'store/planStore';
import { useParams } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { getMetaPredictionsValidity } from '../../../../../../../api/services/mediaPlanning/getMetaPredictionsValidity';
import useMediaPlanMetaSync from '../../../../hooks/useMediaPlanMetaSync';

const useMetaPredictionsValidity = (
  setMetaValidityDialogOpen?: Dispatch<SetStateAction<boolean>>
) => {
  const { alreadySavedPlanId } = usePlanStore();
  const { id } = useParams();
  const { syncMediaPlan } = useMediaPlanMetaSync();

  const {
    mutate: getMetaPredictions,
    mutateAsync: asyncGetMetaPredictions,
    data: response,
    isLoading,
    isError,
  } = useMutation(
    async () => {
      if (setMetaValidityDialogOpen) {
        setMetaValidityDialogOpen(true);
      }
      return getMetaPredictionsValidity(id ?? alreadySavedPlanId ?? '');
    },
    {
      onSuccess: () => {
        if (id || alreadySavedPlanId) {
          syncMediaPlan(id || alreadySavedPlanId);
        }
      },
    }
  );

  return {
    getMetaPredictions,
    asyncGetMetaPredictions,
    data: response,
    isLoading,
    isError,
  };
};

export default useMetaPredictionsValidity;
